

export const SEND_DIPLOMA_ROUTE = '/player/proxy/send_diploma';
export const SEND_DIPLOMA = 'SEND_DIPLOMA';
export const SEND_DIPLOMA_SUCCESS = 'SEND_DIPLOMA_SUCCESS';